<template>
  <el-dialog
    title="活动评估"
    :visible.sync="dialogVisible"
    width="35%"
    class="assessmentDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="assessmentDialogForm" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="重要程度" prop="importance">
            <el-select v-model="formData.importance" placeholder="请选择">
              <el-option v-for="(item, index) in assessmentList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="支持力度" prop="supportStrength">
            <el-select v-model="formData.supportStrength" placeholder="请选择">
              <el-option v-for="(item, index) in assessmentList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="可执行性" prop="enforceability">
            <el-select v-model="formData.enforceability" placeholder="请选择">
              <el-option v-for="(item, index) in assessmentList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { activityQuery } from '../../service';
export default {
  data () {
    return {
      rules: {
        importance: [
          { required: true, message: '请选择重要程度', trigger: 'change' }
        ],
        supportStrength: [
          { required: true, message: '请选择支持力度', trigger: 'change' }
        ],
        enforceability: [
          { required: true, message: '请选择可执行性', trigger: 'change' }
        ]
      },
      dialogVisible: false,
      formData: {},
      assessmentList: ['高', '中', '低']
    };
  },
  props: {
    activityCode: {
      type: String,
      default: ''
    },
    assessmentDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    assessmentDialogVisible (val) {
      if (!val) {
        this.formData = {};
        this.$refs.assessmentDialogForm.clearValidate();
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    submit () {
      this.$refs['assessmentDialogForm'].validate((valid) => {
        if (valid) {
          this.formData.activityCode = this.activityCode; ;
          activityQuery.activityAssessment(this.formData).then(res => {
            if (res.status === '200') {
              this.$message.success('评价成功');
              this.$emit('handlerSuccess');
            }
          });
        }
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    }
  }
};
</script>

<style scoped>

</style>
